import { useWatch } from "react-hook-form";

/**
 * Returns whether the current cell should be greyed out based on a sibling cell
 * that carries the `grey-row` feature.
 *
 * @param cellClass - The `class` property of the current cell.
 * @param currentCols - All sibling columns in the same row.
 */
const useGreyRowCheck = (
  cellClass: string | undefined,
  currentCols: Record<string, any>,
): boolean => {
  const triggerCol =
    cellClass === "grey-row"
      ? Object.entries(currentCols).find(([, col]: [any, any]) =>
          col.feature?.includes("grey-row"),
        )
      : undefined;

  const triggerColName = triggerCol
    ? triggerCol[1].exclusive
      ? triggerCol[0] + "-exclusive-" + triggerCol[1].exclusive
      : triggerCol[0]
    : "GREY_ROW_CHECK";

  const triggerColValue = useWatch({
    name: triggerColName,
    disabled: cellClass !== "grey-row",
  });

  return !!triggerColName && !!triggerCol && !!triggerColValue;
};

export default useGreyRowCheck;
